import axios from "axios";

export const AxiosConfigAdmin = () => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_PREFIX}_access_token`
  );
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL}/admin`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return instance;
};
export const AxiosConfig = () => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_PREFIX}_access_token`
  );
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return instance;
};

export const AxiosConfigWithAdminToken = () => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_PREFIX}_admin_access_token`
  );
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_EXPLORE_BASE_URL}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return instance;
};

export const AxiosConfigAdminWithAdminToken = () => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_PREFIX}_admin_access_token`
  );
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL_ADMIN}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return instance;
};